import { createAction } from "redux-act";

export const addDoumetationUrl = createAction<string>(
  "Add Documentation Success"
);
